import React, { useState, useEffect } from 'react'
import ArrowIcon from "../../assets/icons/icon-arrow.svg";
import Button from '../button/button_v2';
import InputV3 from '../input/novo/input_v3';
import List from '../list';
import logomini from '../../assets/logo-mini.png';
import cancelaIcon from '../../assets/icons/icon-trash-red.png'
import logobling from '../../assets/logos/bling.png';
import logotiny from '../../assets/logos/tiny.png';
import logoomie from '../../assets/logos/omie.png';
import logocontaazul from '../../assets/logos/contaazul.png';
import logopluga from '../../assets/logos/pluga.png';
import ModalGeneric from '../../components/modal/modalGeneric';
import TextOrStatus from '../textOrStatus';

import { store } from "react-notifications-component";

import { Card, Status, Title, Text, Head, Body, BodyContent, HeadTitle, LogoWrap, IconBtn } from "./style";
import api from '../../services/api';


import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import { descricaoUrlPorFuncao } from "../../services/descricaoUrlIntegracao";

const CardIntegration = ({ ...props }) => {

    const [open, setOpen] = useState(false);

    const [url, setUrl] = useState('');
    const [headers, setHeaders] = useState([]);
    const [editado, setEditado] = useState(false);
    const [status, setStatus] = useState(0);
    const [load, setLoad] = useState(0);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteIntegrationId, setDeleteIntegrationId] = useState(0);
    const [saving, setSaving] = useState(false);

    const openBox = () => {
        setOpen(!open);
    }

    const changeUrl = (value) => {
        if (value !== url) {
            setUrl(value);
            setEditado(true);
        }
    }

    const changeHeaders = (value) => {
        let h = headers;

        h = [...h, value];

        setHeaders(h);
        setEditado(true);
    }

    const changeStatus = (value) => {

        let v = value ? 1 : 0;
        
        if(props.status === 0 && load > 0){
            setEditado(true);
            setStatus(v);
        }else{
            if (load < 2) {
                //Foi preciso fazer isso porque o yesno não está funcionando corretamente
                setLoad(load + 1);
                setStatus(props.status);
            } else {
                setEditado(true);
                setStatus(v);
            }

        }
        
    }

    const save = async () => {
        const payload = {
            id: props.id,
            url: url,
            function_id: props.functionId,
            status: status,
            header: headers
        }

        // setOpen(false);
        setEditado(false);
        setSaving(true);

        try {
            await props.save(payload);
        } finally {
            setSaving(false);
        }
    }

    const openDelete = (id) => {
        setDeleteIntegrationId(id);
        setShowDelete(true);
    }

    const deleteIntegration = async () => {
        try {
            if (deleteIntegration !== 0) {
                const response = await api.delete(`/integracao/deletar/${deleteIntegrationId}`);

                if (response) {

                    setShowDelete(false);

                    store.addNotification({
                        title: "Sucesso!",
                        message: response.data.message,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });

                    props.reload();
                }
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

            setShowDelete(false);
        }
    }


    useEffect(() => {
        setUrl(props.url);
    }, [])

    useEffect(() => {
        setHeaders(props.headers)

    }, [props.headers])

    useEffect(() => {
        if (showDelete === false) {
            setDeleteIntegrationId(0);
        }
    }, [showDelete])



    return (

        <Card left={props.left}>

            <Head onClick={() => openBox()}>
                <Status status={props.status} />

                <LogoWrap>
                    {props.framework.framework === 'AgroReceita' ? (
                        <img src={logomini} width='22px' alt='Logo Agroreceita' />
                    ) : props.framework.framework === 'Bling' ? (
                        <img src={logobling} width='30px' alt='Logo Bling' />
                    ) : props.framework.framework === 'Tiny' ? (
                        <img src={logotiny} width='30px' alt='Logo Tiny' />
                    ) : props.framework.framework === 'Omie' ? (
                        <img src={logoomie} width='30px' alt='Logo Omie' />
                    ) : props.framework.framework === 'Conta Azul' ? (
                        <img src={logocontaazul} width='30px' alt='Logo Conta Azul' />
                    ) : null}

                    {props.framework.integration_type.id === 2 && (
                        <img src={logopluga} width='20px' alt='Logo Pluga' />
                    )}
                </LogoWrap>

                <HeadTitle>{props.title}</HeadTitle>

                <TextOrStatus
                    type="status"
                    status={props.status === 1 ? 2 : 3}
                    textSuccess="Ativo"
                    textError="Pausado"
                    maxWidth="auto"
                />

                <IconBtn type="button" className="del" title="Excluir integração" onClick={(e) => { e.stopPropagation(); openDelete(props.id); }}>
                    <img className="cancel" src={cancelaIcon} width='16px' alt='Excluir' />
                </IconBtn>

                <IconBtn type="button" open={open} title={open ? 'Recolher' : 'Expandir'}>
                    <img className="arrow" src={ArrowIcon} width='30px' alt='Expandir' />
                </IconBtn>
            </Head>

            {open && (
                <Body>
                    <BodyContent>
                        <InputV3
                            id="url_id"
                            name="url"
                            floatingLabel='URL'
                            extraInfo={descricaoUrlPorFuncao(props.title)}
                            value={url}
                            onChange={(e) => changeUrl(e.target.value)}
                            yesNo={true}
                            hideYesNo={true}
                            initialYesNoValue={props.status}
                            messageYesNo={'Ativo'}
                            onChangeYesNo={(e) => changeStatus(e)}
                            marginBottom="0px"
                            minHeight="auto"
                        />

                        <List
                            values={headers}
                            onChange={(e) => changeHeaders(e)}
                            id={props.functionId}
                        />

                        <div className="button" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '24px' }}>
                            <Button
                                width='296px'
                                height='50px'
                                value='SALVAR'
                                outline={false}
                                disabled={!editado}
                                loading={saving}
                                onClick={() => save()}
                            />
                        </div>
                    </BodyContent>
                </Body>
            )}

            <ModalGeneric
                show={showDelete}
                size='md'
                onHide={() => setShowDelete(false)}
            >
                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <Title> Deletar integração </Title>
                    <Text> Deseja continuar com a exclusão da integração? </Text>
                    <Text> Este processo é irreversivel! </Text>

                    <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: '10px' }}>
                        <Button 
                            width='150px'
                            height='40px'
                            value='CANCELAR'
                            outline={true}
                            disabled={false}
                            onClick={() => setShowDelete(false)}
                            loading={false}
                        />
    
                        <Button 
                            width='150px'
                            height='40px'
                            value='SIM, EXCLUIR'
                            red={true}
                            outline={false}
                            disabled={false}
                            onClick={() => deleteIntegration()}
                            loading={false}
                        />
                    </div>   
                </div>

            </ModalGeneric>



        </Card>
    )
}

export default CardIntegration;
